import { useState, useEffect } from 'react';
import teamActivityAPIService from '../services/teamActivityAPIService';

// Custom hook for managing team activity data
export const useTeamActivity = (page = 1, teamId = 1) => {
  const [teamActivityPosts, setTeamActivityPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchTeamActivity = async () => {
    try {
      setLoading(true);
      setError(null);
      const activities = await teamActivityAPIService.fetchTeamActivityPosts(page, teamId);
      setTeamActivityPosts(activities);
    } catch (err) {
      console.error('Error fetching team activity:', err);
      setError('Internal Server Error');
      // Don't use fallback data - keep posts empty to show error
      setTeamActivityPosts([]);
    } finally {
      setLoading(false);
    }
  };

  const refreshTeamActivity = () => {
    fetchTeamActivity();
  };

  useEffect(() => {
    fetchTeamActivity();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, teamId]);

  return {
    teamActivityPosts,
    loading,
    error,
    refreshTeamActivity
  };
};

// Custom hook for fetching a single team activity post
export const useTeamActivityPost = (postId) => {
  const [teamActivityPost, setTeamActivityPost] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchTeamActivityPost = async () => {
    if (!postId) {
      setLoading(false);
      return;
    }

    try {
      setLoading(true);
      setError(null);
      const post = await teamActivityAPIService.fetchTeamActivityPostById(postId);
      setTeamActivityPost(post);
    } catch (err) {
      console.error('Error fetching single team activity post:', err);
      setError('Internal Server Error');
      setTeamActivityPost(null);
    } finally {
      setLoading(false);
    }
  };

  const refreshTeamActivityPost = () => {
    fetchTeamActivityPost();
  };

  useEffect(() => {
    fetchTeamActivityPost();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [postId]);

  return {
    teamActivityPost,
    loading,
    error,
    refreshTeamActivityPost
  };
};

export default useTeamActivity;
